import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Section } from './Shared';
const outcomes = ['Meno dispersione.', 'Più ordine.', 'Un metodo che accompagna ciò che sai già.'];
export function FitCheck() {
  return <Section className="max-w-5xl" data-id="element-105" data-mp="1qzsg2vag9wzb">
      <div className="grid gap-10 lg:grid-cols-[2fr_3fr] lg:gap-14" data-id="element-106" data-mp="1qyqsjrc8zi0p">
        <div data-id="element-107" data-mp="1vsbufugyow56">
          <h2 className="text-2xl font-bold tracking-tight text-emerald-900 md:text-4xl" data-id="element-108" data-mp="1vt4uydpbupev">
            E se questa fosse l’ultima consulenza preparata così?
          </h2>
          <p className="mt-5 text-base leading-relaxed text-stone-700 md:text-lg" data-id="element-109" data-mp="24r6zv4c6m27f">
            Immagina di iniziare il prossimo incontro con una guida accanto.
          </p>
        </div>

        <div data-id="element-110" data-mp="2eqxs0zd9s54c">
          <p className="text-base leading-relaxed text-stone-900 md:text-lg" data-id="element-111" data-mp="2epd1rlxzn8ca">
            Hai un percorso da seguire, domande per approfondire e confronti per motivare le scelte. Puoi chiudere con
            un accordo chiaro e ritrovare il filo nell’incontro successivo.
          </p>
          <ul className="mt-6 divide-y divide-stone-200 rounded-xl border border-stone-200 bg-white shadow-sm" data-id="element-112" data-mp="p4eld50yia5b">
            {outcomes.map(outcome => <li key={outcome} className="flex gap-3 p-4 text-sm font-semibold leading-relaxed text-emerald-900 md:text-base" data-id="element-113" data-mp="kc3lg267uocr">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-emerald-700" aria-hidden="true" data-id="element-114" data-mp="bcqbl8e6jxri" />
                {outcome}
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}